import { filter } from 'rxjs/operators';
import { isSourcedAction } from './create-sourced-action.function';
export const ofType = ((...allowedTypes) => {
    return filter((action) => allowedTypes.some(typeOrActionCreator => {
        const actionType = isSourcedAction(action) ? action.typeWithoutSource : action.type;
        const checkedType = typeof typeOrActionCreator === 'string' ?
            typeOrActionCreator :
            typeOrActionCreator.type;
        return checkedType === actionType;
    }));
});
